import timetableControllers from './controllers/_controllers';
import timetableDirectives from './directives/_directives';
import timetableFilters from './filters/_filters';
import timetableResources from './resources/_resources';

import 'Sass/views/timetable.scss';

const moduleName = 'usc.timetable';

/**
 * Check for querystring value where godmode=true
 * @returns {} 
 */
const isGodMode = () => {
    var queryString = location.href.indexOf('?') !== -1 ? location.href.substr(location.href.indexOf('?')) : '',
        params = queryString.substr(1, queryString.length - 1).split('&'),
        i,
        keyValue,
        resp = false;

    for (i = 0; i < params.length; i++) {
        keyValue = params[i].split('=');
        if (keyValue.length &&
            keyValue[0].toLowerCase() === 'godmode' &&
            keyValue[1].toLowerCase().startsWith('true')) {
            resp = true;
        }
    }

    return resp;
};

/**
 * Is localstorage API available?
 * @returns {} 
 */
const checkLocalStorage = () => {
    try {
        return 'localStorage' in window && window['localStorage'] !== null;
    } catch (e) {
        return false;
    }
};

angular.module(moduleName,
    [
        timetableControllers,
        timetableDirectives,
        timetableFilters,
        timetableResources
    ]).constant('timetableConfig',
    {
        'LOCAL_STORE_KEY': '__usc__timetable__',
        'DAYS': ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        'SIDEBAR_MAX': 6,
        'HAS_LOCALSTORAGE': checkLocalStorage(),
        'GODMODE': isGodMode()
    });

const app = angular.module(window.uscApp);
app.requires.push(moduleName);